var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4641 12.3595L35.6086 19.504",
    stroke: "#0688FA",
    strokeWidth: 1.89491,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6624 13.9141C22.1532 12.4028 17.9268 13.0804 15.0615 15.9468C14.4741 16.5343 13.9887 17.1842 13.5851 17.869L17.7033 21.9873",
    stroke: "#0688FA",
    strokeWidth: 1.89491,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0678 22.273C35.6176 25.7954 34.9388 30.0519 32.0544 32.9364C31.4669 33.5238 30.8169 34.0092 30.1322 34.4128L25.9971 30.2777",
    stroke: "#0688FA",
    strokeWidth: 1.89491,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7064 32.0871L15.9103 25.291C15.9103 25.291 21.7153 10.8494 37.9974 10C37.0759 26.2112 22.7064 32.0871 22.7064 32.0871Z",
    stroke: "#0688FA",
    strokeWidth: 1.89491,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7033 19.2934C29.4567 20.0467 29.4567 21.2681 28.7033 22.0214C27.95 22.7747 26.7287 22.7747 25.9754 22.0214C25.222 21.2681 25.222 20.0467 25.9754 19.2934C26.7287 18.5401 27.95 18.5401 28.7033 19.2934Z",
    stroke: "#0688FA",
    strokeWidth: 0.947456
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2391 31.6106L12.2394 31.6103C13.3784 30.4713 15.2234 30.4713 16.3624 31.6103C17.5014 32.7493 17.5014 34.5942 16.3624 35.7332C16.1617 35.9339 15.7282 36.1651 15.035 36.3709C14.3729 36.5675 13.5961 36.7064 12.8358 36.8024C12.1686 36.8867 11.5341 36.9356 11.0323 36.9638C11.0579 36.4585 11.1038 35.8185 11.1853 35.1457C11.2779 34.3818 11.4134 33.6017 11.6075 32.9374C11.8108 32.2413 12.0406 31.8089 12.2391 31.6106Z",
    stroke: "#0688FA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.dd462e8c2235d9ea72bd579e260bd5bc.svg";
export { ForwardRef as ReactComponent };